<template>
  
  <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li
          class="tabLi"
          v-for="(data,$index) in langData"
          :key="$index"
          :class="{'active':$index==0}"
        >
          <div class="tabDiv" @click="changeTab($index)"></div>
          <a
            :class="true?'tab'+$index:''"
            data-toggle="tab"
            :href="true?'#tab-'+$index:''"
            aria-expanded="true"
            @click="showTab($event,$index)"
          >{{ $t("message." + data) }}</a>
        </li>
      </ul>
    </div>
    <el-form  :model="promotionDetail" ref="promotionDetail"  label-width="0px" class="demo-dynamic form-horizontal detailPage">
      <div class="tab-content">
        <div
          :id="'tab-'+index"
          v-for="(langItem, index) in promotionDetail.langMap"
          :key="index"
          class="tab-pane"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Title<span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <el-form-item 
                      :prop="'langMap.' + index + '.title'"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'blur'
                      }"
                    >
                    <el-input v-model="langItem.title" show-word-limit :maxlength="langItem.langCode=='en_US'?32:12" ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Description<span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <el-form-item 
                      :prop="'langMap.' + index + '.description'"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'blur'
                      }"
                    >
                    <el-input v-model="langItem.description" show-word-limit :maxlength="langItem.langCode=='en_US'?43:18" ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Image<span style="color:red">*</span>
                </label>
                <div class="col-sm-5">
                  <el-form-item 
                      :prop="'langMap.' + index + '.image'"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'change'
                      }"
                    >
                      <el-input  v-model="langItem.image" :change="setImage(promotionDetail.langMap,langItem.image,'image')" style="display:none" ></el-input>
                      <file-upload
                        :fileUploadUrl="fileUploadUrl"
                        :limit="5"
                        v-model="langItem.image"
                      >
                        <template v-slot:sizeError>
                          <div style="color:red">Size error!</div>
                        </template>
                        <template v-slot:dimensionError>
                          <div style="color:red">Dimension Error!</div>
                        </template>
                        <template v-slot:sizeHint>
                        <div style="font-size:12px;">Suggested Size: 322 X 128</div>
                        <div>Max 5 MB.</div>
                        </template>
                      </file-upload>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  URL<span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <el-form-item 
                      :prop="'langMap.' + index + '.url'"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'blur'
                      }"
                    >
                    <el-input v-model="langItem.url" show-word-limit ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Start Date
                </label>
                <div class="col-sm-4">
                  <div>
                    <el-date-picker
                      v-model="promotionDetail.startDate"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="date"
                      placeholder="">
                    </el-date-picker>
                  </div>
                </div>
                <label class="col-sm-2 control-label">
                  End Date
                </label>
                <div class="col-sm-4">
                  <div>
                    <el-date-picker
                      v-model="promotionDetail.endDate"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="date"
                      placeholder="">
                    </el-date-picker>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Start Time
                </label>
                <div class="col-sm-4">
                  <div>
                    <el-time-select
                      v-model="promotionDetail.startTime"
                      :picker-options="{
                        start: '00:00',
                        step: '00:01',
                        end: '23:59'
                      }"
                      placeholder="">
                    </el-time-select>
                  </div>
                </div>
                <label class="col-sm-2 control-label">
                  End Time
                </label>
                <div class="col-sm-4">
                  <div>
                    <el-time-select
                      v-model="promotionDetail.endTime"
                      :picker-options="{
                        start: '00:00',
                        step: '00:01',
                        end: '23:59'
                      }"
                      placeholder="">
                    </el-time-select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Status<span style="color:red">*</span>
                </label>
                <div class="col-sm-4">
                  <el-form-item 
                      prop="status"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'change'
                      }"
                    >
                    <el-select v-model="promotionDetail.status" clearable >
                        <el-option 
                        v-for="item in statusObj"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div class="btn btn-primary" v-if="!$route.query.id&&checkPermission('EDITORIAL_LIST_NEW')||$route.query.id&&checkPermission('EDITORIAL_LIST_UPDATE')"  @click="checkEvent()">{{$t("message.Save") }}</div>
                    <div class="btn btn-white" @click="showWarning()">{{$t("message.Cancel") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import fileupload from "../components/common/fileupload";
import eventBus from "../eventbus";
import config from "../config";
const upload = require('../upload')

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      promotionDetail:{
        langMap:[{
            langCode:'en_US',
            title:"",
        },{
            langCode:'zh_CN',
            title:"",
        },{
            langCode:'zh_HK',
            title:"",
        }],
        startDate:"",
        endDate:"",
        startTime:"",
        endTime:"",
        status:""
      },
    };
  },
  computed:{
      _language(){
        return this.$store.state.userInfo.langCode
      }
  },
  watch: {
    _language:function(){
      this.setObj();
    },
    promotionDetail: {
        handler: function(val, oldval) {
          this.$store.state.edit = true;
        },
        deep: true
    }
  },
  components: {
    "file-upload": fileupload
  },
  created() {
    this.setObj();
    this.init();
  },
  mounted() {
    setTimeout(function(){
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    })
  },
  methods: {
    setObj:function(){
      this.statusObj = [
        {
          value: "0",
          label: "Draft",
        },
        {
          value: "1",
          label: "Unpublish",
        },
        {
          value: "2",
          label: "Expired",
        },
        {
          value: "10",
          label: "Publish",
        },
      ];
    },
    setImage(obj,value,item){
      for(var i=0;i<obj.length;i++){
        if(!obj[i][item]&&value){
          obj[i][item] = value
        }
      }
    },
    setItemIamge(result,item){
      item.image = result.fullName
    },
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj();
        obj.promotionId = id;
        obj.apiUrl = '/getPromotionDetail'
        let data = await this.$store.dispatch("apiEvent", obj);
        if(!data) return;
        data.data.result.status+="";
        this.$set(this, "promotionDetail", data.data.result);
        var that = this;
        setTimeout(function(){
          that.$store.state.edit = false;
        })
      } else {
      }
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        this.goBack();
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [{
              name:this.$i18n.t("message.Confirm"),
              callBack:function(){
                that.callDelete();
              }
            }, {
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){}
            }]
        });
      }
    },
    checkEvent:function(){

        this.$refs["promotionDetail"].validate((valid) => {
          if (valid) {
            this.submit();
          } else {
            this.$toastr.w(this.$i18n.t("message.fillRequired"));
            return false;
          }
        });
    },
    goBack() {
      this.$router.push({
        path: "/main/promotionList",
        query: { ...this.$route.query }
      });
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        for(var key in this.promotionDetail){
          var detail = JSON.stringify(this.promotionDetail[key])
          obj[key] = JSON.parse(detail);
        }
        
        obj.langMap = JSON.stringify(obj.langMap);
        if(this.$route.query.id){
          obj.promotionId = this.$route.query.id
          obj.apiUrl = '/updatePromotion'
          var data = await this.$store.dispatch("apiEvent", obj);
        }else{
          obj.apiUrl = '/createPromotion'
          var data = await this.$store.dispatch("apiEvent", obj);
        }
        if(!data) return;
        if (data.data.errorCode === 0) {
          this.$store.state.edit = false;
          this.goBack();
        }
      } catch (err) {
      }
    },
    Delete() {
      this.showWarning(1);
    },
    langLabel(lang) {
      if (lang === "en_US") {
        return "EN";
      } else if (lang === "zh_HK") {
        return "T. Chi.";
      } else if (lang === "zh_CN") {
        return "S. Chi.";
      }
    },
    changeTab: function(id) {
      $(".tab" + id)
        .parent()
        .find("a")
        .click();
    },
    showTab: function($event, tabId) {
      
      $event.preventDefault();
      switch (tabId) {
        case "1":
          $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
  }
};
</script>
